/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gaudy_Lucky_Parakeet_TripInputs */

const fr_gaudy_lucky_parakeet_trip = /** @type {(inputs: Gaudy_Lucky_Parakeet_TripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image de couverture`)
};

/**

* @param {Gaudy_Lucky_Parakeet_TripInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const gaudy_lucky_parakeet_trip = /** @type {((inputs?: Gaudy_Lucky_Parakeet_TripInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gaudy_Lucky_Parakeet_TripInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_gaudy_lucky_parakeet_trip(inputs)
});